import { CookieMinusIcon } from './CookieMinusIcon';

/**
 * author: Colton Wiscombe
 * id 215F338E-A35C-4C54-9AC7-C4F4BB9A7206
 * name cookie-minus
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-minus.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitMinusIcon = CookieMinusIcon;
export default BiscuitMinusIcon